import { render, staticRenderFns } from "./ClinicianPatientForm.vue?vue&type=template&id=43b03674&scoped=true"
import script from "./ClinicianPatientForm.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientForm.vue?vue&type=script&lang=js"
import style0 from "./ClinicianPatientForm.vue?vue&type=style&index=0&id=43b03674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b03674",
  null
  
)

export default component.exports